export const uiMotion = {
  duration: {
    fast: "duration-150",
    normal: "duration-200",
    slow: "duration-300",
  },
  easing: {
    smooth: "ease-out",
    snappy: "ease-in-out",
  },
  transition: {
    default: "transition-all duration-200 ease-out",
    colors: "transition-colors duration-200 ease-out",
    transform: "transition-transform duration-200 ease-out",
  },
};

export const pageMotionVariants = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -8 },
  transition: { duration: 0.22, ease: "easeOut" },
};
